import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Helmet from 'react-helmet';
import { store } from './redux';
import { Navbar } from './components';
import views from './views';
import * as views1 from './views';
import ErrorView from './views/Error';
import { checkAuth, getJWT, setAuthHeader } from './actions/auth';
import { appLoaded } from './actions/app';
import { pdfjs } from 'react-pdf';
import { Button, Card, Flex, Space, Typography } from 'antd';
import './index.scss';
import './scss/style.scss';
import "./styles/tailwind.css";
import { SocketProvider } from './sockets/WebSocketContext';
import ReduxDevTools from './components/ReduxDevTools/ReduxDevTools';
import { ApolloProvider } from '@apollo/client';
import client from './apolloClient';
import RouteWatcher from './RouteWatcher';
const { Title, Paragraph } = Typography;
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// Suppress ResizeObserver errors (harmless browser warnings from Ant Design components)
const originalError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (
    typeof message === 'string' &&
    message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return true; // Suppress this specific error
  }
  if (originalError) {
    return originalError(message, source, lineno, colno, error);
  }
  return false;
};

window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

let viewsAccess = null;
const excludedPaths = ["/apply", '/online-exam/', '/instructions/']

const pathIncludes = () => {
  return excludedPaths.some((path) => window.location.pathname.includes(path));
}

const rootElement = document.getElementById('app');
if (!rootElement) throw new Error("Root element not found");
const root = createRoot(rootElement as HTMLElement);

(async () => {
  try {
    const jwt = await store.dispatch(getJWT());
    if (jwt) {
      await store.dispatch(setAuthHeader(jwt));
      const result = await store.dispatch(checkAuth());
      store.dispatch(appLoaded());
      if (result) { viewsAccess = await views1.getAccess(store.dispatch); }
    } else {
      store.dispatch(appLoaded());
      if (
        !(await store.dispatch(getJWT())) &&
        !views.find((view) => view.path == window.location.pathname) && !pathIncludes()
      ) {
        console.log('redirecting to login');
        window.location.replace('/login');
      }
    }
  } catch (e) {
    console.log('Error during app initialization', e);
    root.render(
      <Flex justify="center" align='center' style={{ height: '60vh' }}>
        <Card style={{ width: 350, height: 250, textAlign: 'center' }}>
          <Space direction='vertical'>
            <Title level={5} style={{ color: 'red' }}>
              {process.env.APP_NAME} is Offline
            </Title>
            <Paragraph>
              There was a problem connecting to {process.env.APP_NAME}.
              we apologise for any inconvenience caused. Please try again later. If the problem persists, please contact the administrator.
            </Paragraph>
            <Button type='link' onClick={() => window.location.href = '/'}>Reload</Button>
          </Space>
        </Card>
      </Flex>
    );
    return;
  }
  console.log('App initialized');
  root.render(
    <Provider store={store}>
      <SocketProvider>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <>
              <RouteWatcher />
              <Helmet titleTemplate={`%s | ${process.env.APP_NAME}`} />
              <Routes>
                {views.map((view) => {
                  const Component = view.component;
                  return <Route
                    key={view.path}
                    path={`${view.path}/*`}
                    element={<Component />}
                  />
                })}
                <Route path="/*" element={<Navbar
                  routes={<Routes>
                    {views1.extraRoutes && views1.extraRoutes.map((view) => {
                      const Component = view.component;
                      return <Route
                        key={view.path}
                        path={`${view.path}/*`}
                        element={<Component />}
                      />
                    })}
                    {viewsAccess &&
                      viewsAccess.map((view) => {
                        const Component = view.component;
                        return <Route
                          key={view.path}
                          path={`${view.path}/*`}
                          element={<Component />}
                        />
                      })}
                  </Routes>
                  }
                />
                } />
                < Route Component={ErrorView} />
              </Routes>
              {process.env.NODE_ENV === "development" && <ReduxDevTools />}
            </>

          </BrowserRouter>
        </ApolloProvider>
      </SocketProvider>
    </Provider>
  );
})();
